<nv-note size="small" priority="info">
	{{ summerAttendanceMessage.defaultText }}
	<ng-container *ngIf="summerAttendanceMessage.linkText">
		{{ summerAttendanceMessage.preLinkText }}
		<a *ngIf="hasSummerSchoolList" (click)="goToSummerList()" class="unformatted-link">
		{{ summerAttendanceMessage.linkText }}
		</a>
	</ng-container>
</nv-note>